import { IApplication } from "@rentiohq/shared-frontend/dist/types/application.types";
import { useState, useRef } from "react";
import { IDropArea } from "../PropertyDetailApplications";
import { DragAndDropContext } from "./DragAndDropContext";

interface IProps {
  children: React.ReactNode;
}

export const DragAndDropContextProvider = ({ children }: IProps) => {
  const [selectedItems, setSelectedItems] = useState<IApplication[]>([]);
  const [allDropAreas, setAllDropAreas] = useState<IDropArea[]>([]);
  const [isGlobalDragging, setIsGlobalDragging] = useState<boolean>(false);
  const [hoveredTab, setHoveredTab] = useState<string | null>(null);
  const hoveredTabRef = useRef<string | null>(null);

  const onSelectItem = (item: IApplication) => {
    setSelectedItems([...selectedItems, item]);
  };

  const onSelectAll = (items: IApplication[]) => {
    setSelectedItems(items);
  };

  const onUnselectItem = (item: IApplication) => {
    setSelectedItems(selectedItems.filter(i => i.id !== item.id));
  };

  const onUnselectAll = (items: IApplication[]) => {
    const itemIds = items.map(item => item.id);
    setSelectedItems(selectedItems.filter(i => !itemIds.includes(i.id)));
  };

  const replaceSelectedItems = (items: IApplication[]) => {
    setSelectedItems(items);
  };

  const handleSetHoveredTab = (tabId: string | null) => {
    hoveredTabRef.current = tabId;
    setHoveredTab(tabId);
  };

  return (
    <DragAndDropContext.Provider
      value={{
        selectedItems,
        allDropAreas,
        onSelectItem,
        onSelectAll,
        onUnselectItem,
        onUnselectAll,
        replaceSelectedItems,
        setAllDropAreas,
        isGlobalDragging,
        setIsGlobalDragging,
        hoveredTab,
        setHoveredTab: handleSetHoveredTab,
        hoveredTabRef,
      }}
    >
      {children}
    </DragAndDropContext.Provider>
  );
};
